import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  OTPContent,
  OTPHeader,
  ScreenWrapper,
  OTPResend,
  OTPLabel,
  OTPResendTimer,
  ErrorText
} from "./styles";
import { OtpTextInput } from "share/atoms/form-fields";
import { SubmitButton } from "school-admin/Login/styles";
import Timer from "share/atoms/Timer";
import { otpVerifyReset, resendOTPRequest } from "./actions";
import { useQuery } from "share/atoms/use-query";

function OTPScreen({ handleLogin, handleNotYourID, error }) {
  const dispatch = useDispatch();
  const query = useQuery();
  const {
    employeeVerifyReducer: {
      data: { mobile_number, employee_id }
    }
  } = useSelector((state) => state.studentLogin);
  const [otp, setOtp] = useState("");
  const [enableResend, setEnableResend] = useState(false);

  const seconds = sessionStorage.getItem("n-otp-sec");

  const timerStatus = (count) => {
    setEnableResend(true);
  };
  const changeHandler = (e) => {
    setOtp(e);
    dispatch(otpVerifyReset());
  };
  const callback = () => {
    setOtp("");
    dispatch(otpVerifyReset());
    setEnableResend(false);
  };
  const onNotYourID = (e) => {
    e.preventDefault();
    handleNotYourID();
    dispatch(otpVerifyReset());
  };
  const handleResend = (e) => {
    e.preventDefault();
    dispatch(
      resendOTPRequest({
        employee_id: employee_id || sessionStorage.getItem("n-emp-id"),
        callback
      })
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    return String(otp).length ? handleLogin(otp) : null;
  };

  return (
    <form onSubmit={handleSubmit}>
      <ScreenWrapper style={{ justifyContent: "space-between" }}>
        <div>
          <OTPHeader>OTP Verification</OTPHeader>
          <OTPContent>
            OTP has been sent to the mobile number{" "}
            {mobile_number || sessionStorage.getItem("n-mob-no")} for your
            Narayana Global ID{" "}
            <span className="id">
              {employee_id || sessionStorage.getItem("n-emp-id")}
            </span>
          </OTPContent>
          <OTPResend>
            <button onClick={onNotYourID} type="button">
              Not your ID?
            </button>
          </OTPResend>
        </div>
        <div>
          <OTPLabel>Enter OTP</OTPLabel>
          <OtpTextInput
            handleChange={changeHandler}
            otp={otp}
            inputLength={4}
            error={error}
          />
          {error && <ErrorText>{error}</ErrorText>}
        </div>
        <OTPResendTimer style={{ marginBottom: "-10px" }}>
          <div>
            <Timer
              seconds={seconds}
              startTimer={enableResend}
              timerCompleted={timerStatus}
              hasWarning={true}
              prefixText="Resend in"
              handleResend={handleResend}
            />
          </div>
        </OTPResendTimer>

        <SubmitButton style={{ width: "100%" }} type="submit">
          Login
        </SubmitButton>
      </ScreenWrapper>
    </form>
  );
}

export default OTPScreen;
